import { useCallback, useEffect, useState } from 'react';

const STORAGE_KEY = 'stj:activityView';
const VALID = ['list', 'grid2', 'grid3'];

/**
 * Remembers how the visitor likes the activity results laid out:
 *   grid2 (default) - big cards, two across
 *   grid3           - three across
 *   list            - one wide row per trip
 * Never throws if localStorage is unavailable (private mode, etc).
 */
export const useActivityView = (defaultView = 'grid2') => {
  const [view, setView] = useState(defaultView);

  useEffect(() => {
    try {
      const saved = window.localStorage.getItem(STORAGE_KEY);
      if (VALID.includes(saved)) setView(saved);
      else if (saved === 'grid') setView('grid2'); // value stored before the column choice existed
    } catch (error) {
      /* storage blocked - keep the default */
    }
  }, []);

  const changeView = useCallback((next) => {
    if (!VALID.includes(next)) return;
    setView(next);
    try {
      window.localStorage.setItem(STORAGE_KEY, next);
    } catch (error) {
      /* storage blocked - the choice just will not persist */
    }
  }, []);

  return [view, changeView];
};

export default useActivityView;
